module.exports = ".organization-list-page {\n  padding: 20px; }\n\n.study-loading-placeholder {\n  padding: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/study-container-page/organization-list-page/organization-list-page.component.scss
// module id = ./src/app/pages/study-container-page/organization-list-page/organization-list-page.component.scss
// module chunks = main